import { createFileRoute } from '@tanstack/react-router';
import { MaterialModal } from 'src/components/creator/MaterialModal';

const CreatePdfMaterialRoute = () => <MaterialModal defaultFormat="pdf" />;

export const Route = createFileRoute(
  '/_authenticated/_creator/materials/create/pdf'
)({
  component: CreatePdfMaterialRoute,
});
